import { Stack } from '@mui/material'
import React from 'react'

export default function InvertableStack({children, ...rest}) {
  return (
    <Stack  direction={{ xs: "column", md: "row" }} spacing={2} display={"flex"} {...rest}>{children}</Stack>
  )
}
